import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, FormControl, FormHelperText, RadioGroup, FormControlLabel, Radio, Paper, MenuItem } from '@material-ui/core';
import { INTERESADO_BIENESTAR } from '../../../helper';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';
import { useTheme } from '@material-ui/core/styles';
import { useFormValidation } from './useFormValidation';

/* ================================
   STEP 1 - INFORMACIÓN GENERAL
================================ */

const InformacionGeneral = ({ state, onChange, onError, pintarSelect, solicitud }) => {
    const { safeValue, safeError, conError } = useFormValidation(state);
    const [interesado, setInteresado] = useState([]);
    const theme = useTheme();

    useEffect(() => {

        if (solicitud?.usuario_registro) {

            const usuario = solicitud.usuario_registro;

            const nombreCompleto = `
                ${usuario.primer_nombre || ''} 
                ${usuario.segundo_nombre || ''} 
                ${usuario.primer_apellido || ''} 
                ${usuario.segundo_apellido || ''}
            `.replace(/\s+/g, ' ').trim();

            onChange({
                target: {
                    name: 'nombre_completo',
                    value: nombreCompleto
                }
            });

            onChange({
                target: {
                    name: 'documento_identidad',
                    value: usuario.identificacion || ''
                }
            });

            onChange({
                target: {
                    name: 'numero_contacto',
                    value: usuario.celular || usuario.telefono || ''
                }
            });
        }

        const cargarTodo = async () => {
            await Promise.all([
                cargarCatalogo(INTERESADO_BIENESTAR, setInteresado),
            ]);
        };
        cargarTodo();

    }, [solicitud]);

    return (
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        La activación de la Ruta debe ser una decisión autónoma, libre, consentida e informada.
                        Este proceso garantiza atención integral, orientación jurídica y reserva de identidad.
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre Completo"
                    name="nombre_completo"
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={conError(safeError('nombre_completo'))}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="No. de documento"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={conError(safeError('documento_identidad'))}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Lugar de Expedición"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={conError(safeError('lugar_expedicion'))}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
            <TextField
                fullWidth
                select
                label="Calidad del Usuario"
                name="rol_usuario"
                value={safeValue('rol_usuario')}
                onChange={onChange}
                error={conError(safeError('rol_usuario'))}
                helperText={safeError('rol_usuario')}
                >
                {interesado.map((opcion) => (
                <MenuItem key={opcion.value} value={opcion.label}>
                    {opcion.label}
                </MenuItem>
                ))}
            </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={conError(safeError('numero_contacto'))}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>

        </Grid>
    );
};


/* ================================
   STEP 2 - DECISIÓN DE ACTIVACIÓN
================================ */

const DecisionActivacion = ({ state, onChange }) => {

    const { safeValue, safeError, conError } = useFormValidation(state);
    const theme = useTheme();

    return (
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        Doy fe que se me ha explicado tanto el alcance como los límites del proceso
                        que se surte con la ruta, y en este sentido, tomo la decisión de:
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <FormControl error={conError(safeError('decision_activacion'))}>
                    <RadioGroup
                        name="decision_activacion"
                        value={safeValue('decision_activacion')}
                        onChange={onChange}
                    >
                        <FormControlLabel
                            value="ACTIVAR"
                            control={<Radio color="primary" />}
                            label="Deseo ACTIVAR la Ruta"
                        />

                        <FormControlLabel
                            value="NO_ACTIVAR"
                            control={<Radio color="secondary" />}
                            label="Deseo NO ACTIVAR la Ruta"
                        />
                    </RadioGroup>
                    <FormHelperText>{safeError('decision_activacion')}</FormHelperText>
                </FormControl>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="caption" display="block" gutterBottom>
                    * Recuerde que en cualquier momento del procedimiento usted puede desistir del mismo.
                </Typography>
            </Grid>

        </Grid>
    );
};


/* ================================
   EXPORT STEPS
================================ */

export const Formulario002Steps = [

    {
        label: 'Información General',
        render: (props) => <InformacionGeneral {...props} />
    },

    {
        label: 'Decisión de Activación',
        render: (props) => <DecisionActivacion {...props} />
    }

];